import { formatDate } from "./dateUtils";

/**
 * الحصول على مصفوفة المدعوين من بيانات الخادم
 */
export const attendeesArrayFromBackend = (ev) => {
  if (!ev || ev.attendees == null) return [];

  if (typeof ev.attendees === "string") {
    try {
      const parsed = JSON.parse(ev.attendees);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {
      // not JSON, fallthrough
    }
  }

  if (Array.isArray(ev.attendees)) {
    return ev.attendees
      .map((a) => {
        if (!a) return null;
        if (typeof a === "string") return a;
        return a.user?.email || a.employee?.email || a.email || null;
      })
      .filter(Boolean);
  }

  if (typeof ev.attendees === "object") {
    const a = ev.attendees;
    return [a.user?.email || a.employee?.email || a.email].filter(Boolean);
  }

  return [];
};

/**
 * تحويل بيانات الخادم إلى واجهة المستخدم
 */
export const mapBackendToUI = (ev, eventTypes, t) => {
  const start = ev.start ? new Date(ev.start) : null;
  const end = ev.end ? new Date(ev.end) : null;
  const date = start ? formatDate(start) : null;
  const time = start ? start.toTimeString().slice(0, 5) : "";
  const duration =
    start && end
      ? Math.round((end - start) / (60 * 1000))
      : ev.duration || 60;

  const attendeesEmails = attendeesArrayFromBackend(ev);
  const attendeesString = attendeesEmails.join(", ");

  return {
    id: ev.id,
    title: ev.title,
    date,
    time,
    duration,
    type: ev.type || "meeting",
    location: ev.location || "",
    attendees: attendeesString,
    description: ev.description || "",
    priority: ev.priority || "medium",
    isRecurring: !!ev.recurrenceRule,
    recurrenceRule: ev.recurrenceRule || "",
    assignedBy: ev.assignedBy,
    status: ev.status || "scheduled",
    reminder: !!ev.reminder,
    color: eventTypes.find((t) => t.id === ev.type)?.color || "#2e7cba",
    raw: ev,
    originatorCode: ev.originatorCode || ev.infinityCode || null,
    originatorName: ev.originatorName || t.loading,
  };
};

/**
 * تحويل بيانات واجهة المستخدم إلى الخادم
 */
export const mapUIToBackend = (ui, currentInfinityCode) => {
  const start =
    ui.date && ui.time ? new Date(`${ui.date}T${ui.time}:00`) : null;

  let end = null;

  if (ui.endDate && (ui.type === "vacation" || ui.endDate !== ui.date)) {
    end = new Date(`${ui.endDate}T23:59:59`);
  } else if (start) {
    end = new Date(start.getTime() + Number(ui.duration || 60) * 60000);
  }

  const attendeesArray = ui.attendees
    ? ui.attendees
        .split(",")
        .map((email) => (email || "").trim())
        .filter((email) => email.length > 0)
    : [];

  return {
    title: ui.title,
    description: ui.description,
    start: start ? start.toISOString() : null,
    end: end ? end.toISOString() : null,
    endDate: ui.endDate || null,
    type: ui.type,
    location: ui.location,
    priority: ui.priority,
    status: ui.status,
    reminder: !!ui.reminder,
    attendees: attendeesArray,
    recurrenceRule: ui.recurrenceRule || null,
    infinityCode: ui.infinityCode || currentInfinityCode || null,
    originatorCode: ui.originatorCode || currentInfinityCode || null,
    originatorName: ui.originatorName || null,
  };
};
